// extracted by mini-css-extract-plugin
module.exports = {"AnswersListContainer":"AnswersList_AnswersListContainer__12Bl_","break":"AnswersList_break__3lEl3"};